export default __webpack_public_path__ + "assets/images/2b4399290d08e319d0dbdbbcc2e81187.png";